import type { LayoutLoad } from './$types';

export const load: LayoutLoad = ({ params }) => (
  {
    area: params.area,
  }
);
